export const formatTabs = ( list = [] ) => {
	let formattedList = [];

	formattedList = list
		?.filter ( item => ( item?.apiEndpoint !== "images" ) )
		?.map ( item => ( { value: item.apiEndpoint, label: item.displayName } ) );

	return formattedList;

};

